import * as Sentry from '@sentry/nextjs';

export type StatePayloadValue = string | number | boolean | null | undefined;

/**
 * Signup-form values (username, account type, lat/lng) that must survive a social sign-in
 * round-trip — a Firebase popup or the VAIR redirect. Read + cleared by ModalCompleteProfile.
 */
export const OAUTH_SIGNIN_STATE_KEY = 'bounce-oauth-signin-state';

export const persistStatePayload = (payload?: Record<string, StatePayloadValue>) => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    const cleanedEntries = Object.entries(payload ?? {}).filter(([, value]) => value !== undefined);

    if (!cleanedEntries.length) {
      window.localStorage.removeItem(OAUTH_SIGNIN_STATE_KEY);
      return;
    }

    window.localStorage.setItem(
      OAUTH_SIGNIN_STATE_KEY,
      JSON.stringify(Object.fromEntries(cleanedEntries)),
    );
  } catch (storageError) {
    Sentry.captureException(storageError);
  }
};
